/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { ApprovePayoutRequestDto } from "../types/approvePayoutRequestDto";

import type { BulkApprovePayoutRequestsDto } from "../types/bulkApprovePayoutRequestsDto";

import type { BulkApprovePayoutRequestsResultDto } from "../types/bulkApprovePayoutRequestsResultDto";

import type { CreateFsmPayoutRequestDto } from "../types/createFsmPayoutRequestDto";

import type { CreateOpportunityClaimPayoutRequestDto } from "../types/createOpportunityClaimPayoutRequestDto";

import type { DenyPayoutRequestDto } from "../types/denyPayoutRequestDto";

import type { FsmPayoutRequestDetailDto } from "../types/fsmPayoutRequestDetailDto";

import type { ListPayoutRequestsParams } from "../types/listPayoutRequestsParams";

import type { PayoutRequestDto } from "../types/payoutRequestDto";

import type { PayoutRequestEvidenceDto } from "../types/payoutRequestEvidenceDto";

import type { PayoutRequestListItemDtoPaginatedResult } from "../types/payoutRequestListItemDtoPaginatedResult";

import type { PayoutRequestSourceDto } from "../types/payoutRequestSourceDto";

import type { PayoutRequestStatsDto } from "../types/payoutRequestStatsDto";

import type { ProblemDetails } from "../types/problemDetails";

import type { ReturnPayoutRequestDto } from "../types/returnPayoutRequestDto";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_LIST
 */
export const listPayoutRequests = (
  params?: ListPayoutRequestsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutRequestListItemDtoPaginatedResult>> => {
  return axios.default.get(`/api/payout-requests`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getListPayoutRequestsQueryKey = (
  params?: ListPayoutRequestsParams,
) => {
  return [`/api/payout-requests`, ...(params ? [params] : [])] as const;
};

export const getListPayoutRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPayoutRequests>>,
  TError = AxiosError<void>,
>(
  params?: ListPayoutRequestsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPayoutRequests>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPayoutRequestsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPayoutRequests>>
  > = ({ signal }) => listPayoutRequests(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPayoutRequests>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPayoutRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPayoutRequests>>
>;
export type ListPayoutRequestsQueryError = AxiosError<void>;

export function useListPayoutRequests<
  TData = Awaited<ReturnType<typeof listPayoutRequests>>,
  TError = AxiosError<void>,
>(
  params?: ListPayoutRequestsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPayoutRequests>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPayoutRequestsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_LIST
 */
export const getPayoutRequestStats = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutRequestStatsDto>> => {
  return axios.default.get(`/api/payout-requests/stats`, options);
};

export const getGetPayoutRequestStatsQueryKey = () => {
  return [`/api/payout-requests/stats`] as const;
};

export const getGetPayoutRequestStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPayoutRequestStats>>,
  TError = AxiosError<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPayoutRequestStats>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPayoutRequestStatsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPayoutRequestStats>>
  > = ({ signal }) => getPayoutRequestStats({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPayoutRequestStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPayoutRequestStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPayoutRequestStats>>
>;
export type GetPayoutRequestStatsQueryError = AxiosError<void>;

export function useGetPayoutRequestStats<
  TData = Awaited<ReturnType<typeof getPayoutRequestStats>>,
  TError = AxiosError<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPayoutRequestStats>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPayoutRequestStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const getPayoutRequestById = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutRequestDto>> => {
  return axios.default.get(`/api/payout-requests/${id}`, options);
};

export const getGetPayoutRequestByIdQueryKey = (id?: string) => {
  return [`/api/payout-requests/${id}`] as const;
};

export const getGetPayoutRequestByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPayoutRequestById>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayoutRequestById>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPayoutRequestByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPayoutRequestById>>
  > = ({ signal }) => getPayoutRequestById(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPayoutRequestById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPayoutRequestByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPayoutRequestById>>
>;
export type GetPayoutRequestByIdQueryError = AxiosError<void | ProblemDetails>;

export function useGetPayoutRequestById<
  TData = Awaited<ReturnType<typeof getPayoutRequestById>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayoutRequestById>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPayoutRequestByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const getPayoutRequestSource = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutRequestSourceDto>> => {
  return axios.default.get(`/api/payout-requests/${id}/source`, options);
};

export const getGetPayoutRequestSourceQueryKey = (id?: string) => {
  return [`/api/payout-requests/${id}/source`] as const;
};

export const getGetPayoutRequestSourceQueryOptions = <
  TData = Awaited<ReturnType<typeof getPayoutRequestSource>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayoutRequestSource>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPayoutRequestSourceQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPayoutRequestSource>>
  > = ({ signal }) => getPayoutRequestSource(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPayoutRequestSource>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPayoutRequestSourceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPayoutRequestSource>>
>;
export type GetPayoutRequestSourceQueryError =
  AxiosError<void | ProblemDetails>;

export function useGetPayoutRequestSource<
  TData = Awaited<ReturnType<typeof getPayoutRequestSource>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayoutRequestSource>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPayoutRequestSourceQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const getFsmPayoutRequestDetail = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FsmPayoutRequestDetailDto>> => {
  return axios.default.get(`/api/payout-requests/fsm/${id}`, options);
};

export const getGetFsmPayoutRequestDetailQueryKey = (id?: string) => {
  return [`/api/payout-requests/fsm/${id}`] as const;
};

export const getGetFsmPayoutRequestDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getFsmPayoutRequestDetail>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFsmPayoutRequestDetail>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFsmPayoutRequestDetailQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFsmPayoutRequestDetail>>
  > = ({ signal }) =>
    getFsmPayoutRequestDetail(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFsmPayoutRequestDetail>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFsmPayoutRequestDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFsmPayoutRequestDetail>>
>;
export type GetFsmPayoutRequestDetailQueryError =
  AxiosError<void | ProblemDetails>;

export function useGetFsmPayoutRequestDetail<
  TData = Awaited<ReturnType<typeof getFsmPayoutRequestDetail>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFsmPayoutRequestDetail>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFsmPayoutRequestDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const getPayoutRequestEvidence = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutRequestEvidenceDto>> => {
  return axios.default.get(`/api/payout-requests/${id}/evidence`, options);
};

export const getGetPayoutRequestEvidenceQueryKey = (id?: string) => {
  return [`/api/payout-requests/${id}/evidence`] as const;
};

export const getGetPayoutRequestEvidenceQueryOptions = <
  TData = Awaited<ReturnType<typeof getPayoutRequestEvidence>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayoutRequestEvidence>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPayoutRequestEvidenceQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPayoutRequestEvidence>>
  > = ({ signal }) => getPayoutRequestEvidence(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPayoutRequestEvidence>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPayoutRequestEvidenceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPayoutRequestEvidence>>
>;
export type GetPayoutRequestEvidenceQueryError =
  AxiosError<void | ProblemDetails>;

export function useGetPayoutRequestEvidence<
  TData = Awaited<ReturnType<typeof getPayoutRequestEvidence>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayoutRequestEvidence>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPayoutRequestEvidenceQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_CREATE
 */
export const createPayoutRequestFromOpportunityClaim = (
  createOpportunityClaimPayoutRequestDto: CreateOpportunityClaimPayoutRequestDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutRequestDto>> => {
  return axios.default.post(
    `/api/payout-requests/from-opportunity-claim`,
    createOpportunityClaimPayoutRequestDto,
    options,
  );
};

export const getCreatePayoutRequestFromOpportunityClaimMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPayoutRequestFromOpportunityClaim>>,
    TError,
    { data: CreateOpportunityClaimPayoutRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPayoutRequestFromOpportunityClaim>>,
  TError,
  { data: CreateOpportunityClaimPayoutRequestDto },
  TContext
> => {
  const mutationKey = ["createPayoutRequestFromOpportunityClaim"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPayoutRequestFromOpportunityClaim>>,
    { data: CreateOpportunityClaimPayoutRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return createPayoutRequestFromOpportunityClaim(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePayoutRequestFromOpportunityClaimMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPayoutRequestFromOpportunityClaim>>
>;
export type CreatePayoutRequestFromOpportunityClaimMutationBody =
  CreateOpportunityClaimPayoutRequestDto;
export type CreatePayoutRequestFromOpportunityClaimMutationError =
  AxiosError<ProblemDetails | void>;

export const useCreatePayoutRequestFromOpportunityClaim = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPayoutRequestFromOpportunityClaim>>,
    TError,
    { data: CreateOpportunityClaimPayoutRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPayoutRequestFromOpportunityClaim>>,
  TError,
  { data: CreateOpportunityClaimPayoutRequestDto },
  TContext
> => {
  const mutationOptions =
    getCreatePayoutRequestFromOpportunityClaimMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_CREATE
 */
export const createPayoutRequestFromFsmCompletedWork = (
  createFsmPayoutRequestDto: CreateFsmPayoutRequestDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutRequestDto>> => {
  return axios.default.post(
    `/api/payout-requests/from-fsm-event`,
    createFsmPayoutRequestDto,
    options,
  );
};

export const getCreatePayoutRequestFromFsmCompletedWorkMutationOptions = <
  TError = AxiosError<void | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPayoutRequestFromFsmCompletedWork>>,
    TError,
    { data: CreateFsmPayoutRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPayoutRequestFromFsmCompletedWork>>,
  TError,
  { data: CreateFsmPayoutRequestDto },
  TContext
> => {
  const mutationKey = ["createPayoutRequestFromFsmCompletedWork"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPayoutRequestFromFsmCompletedWork>>,
    { data: CreateFsmPayoutRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return createPayoutRequestFromFsmCompletedWork(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePayoutRequestFromFsmCompletedWorkMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPayoutRequestFromFsmCompletedWork>>
>;
export type CreatePayoutRequestFromFsmCompletedWorkMutationBody =
  CreateFsmPayoutRequestDto;
export type CreatePayoutRequestFromFsmCompletedWorkMutationError =
  AxiosError<void | ProblemDetails>;

export const useCreatePayoutRequestFromFsmCompletedWork = <
  TError = AxiosError<void | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPayoutRequestFromFsmCompletedWork>>,
    TError,
    { data: CreateFsmPayoutRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPayoutRequestFromFsmCompletedWork>>,
  TError,
  { data: CreateFsmPayoutRequestDto },
  TContext
> => {
  const mutationOptions =
    getCreatePayoutRequestFromFsmCompletedWorkMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_APPROVE
 */
export const approvePayoutRequest = (
  id: string,
  approvePayoutRequestDto: ApprovePayoutRequestDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutRequestDto>> => {
  return axios.default.post(
    `/api/payout-requests/${id}/approve`,
    approvePayoutRequestDto,
    options,
  );
};

export const getApprovePayoutRequestMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approvePayoutRequest>>,
    TError,
    { id: string; data: ApprovePayoutRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approvePayoutRequest>>,
  TError,
  { id: string; data: ApprovePayoutRequestDto },
  TContext
> => {
  const mutationKey = ["approvePayoutRequest"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approvePayoutRequest>>,
    { id: string; data: ApprovePayoutRequestDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return approvePayoutRequest(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApprovePayoutRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof approvePayoutRequest>>
>;
export type ApprovePayoutRequestMutationBody = ApprovePayoutRequestDto;
export type ApprovePayoutRequestMutationError =
  AxiosError<ProblemDetails | void>;

export const useApprovePayoutRequest = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approvePayoutRequest>>,
    TError,
    { id: string; data: ApprovePayoutRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof approvePayoutRequest>>,
  TError,
  { id: string; data: ApprovePayoutRequestDto },
  TContext
> => {
  const mutationOptions = getApprovePayoutRequestMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_BULK_APPROVE
 */
export const bulkApprovePayoutRequests = (
  bulkApprovePayoutRequestsDto: BulkApprovePayoutRequestsDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BulkApprovePayoutRequestsResultDto>> => {
  return axios.default.post(
    `/api/payout-requests/bulk-approve`,
    bulkApprovePayoutRequestsDto,
    options,
  );
};

export const getBulkApprovePayoutRequestsMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkApprovePayoutRequests>>,
    TError,
    { data: BulkApprovePayoutRequestsDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkApprovePayoutRequests>>,
  TError,
  { data: BulkApprovePayoutRequestsDto },
  TContext
> => {
  const mutationKey = ["bulkApprovePayoutRequests"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkApprovePayoutRequests>>,
    { data: BulkApprovePayoutRequestsDto }
  > = (props) => {
    const { data } = props ?? {};

    return bulkApprovePayoutRequests(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkApprovePayoutRequestsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkApprovePayoutRequests>>
>;
export type BulkApprovePayoutRequestsMutationBody =
  BulkApprovePayoutRequestsDto;
export type BulkApprovePayoutRequestsMutationError =
  AxiosError<ProblemDetails | void>;

export const useBulkApprovePayoutRequests = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkApprovePayoutRequests>>,
    TError,
    { data: BulkApprovePayoutRequestsDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkApprovePayoutRequests>>,
  TError,
  { data: BulkApprovePayoutRequestsDto },
  TContext
> => {
  const mutationOptions = getBulkApprovePayoutRequestsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_DENY
 */
export const denyPayoutRequest = (
  id: string,
  denyPayoutRequestDto: DenyPayoutRequestDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutRequestDto>> => {
  return axios.default.post(
    `/api/payout-requests/${id}/deny`,
    denyPayoutRequestDto,
    options,
  );
};

export const getDenyPayoutRequestMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof denyPayoutRequest>>,
    TError,
    { id: string; data: DenyPayoutRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof denyPayoutRequest>>,
  TError,
  { id: string; data: DenyPayoutRequestDto },
  TContext
> => {
  const mutationKey = ["denyPayoutRequest"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof denyPayoutRequest>>,
    { id: string; data: DenyPayoutRequestDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return denyPayoutRequest(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DenyPayoutRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof denyPayoutRequest>>
>;
export type DenyPayoutRequestMutationBody = DenyPayoutRequestDto;
export type DenyPayoutRequestMutationError = AxiosError<ProblemDetails | void>;

export const useDenyPayoutRequest = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof denyPayoutRequest>>,
    TError,
    { id: string; data: DenyPayoutRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof denyPayoutRequest>>,
  TError,
  { id: string; data: DenyPayoutRequestDto },
  TContext
> => {
  const mutationOptions = getDenyPayoutRequestMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_RETURN
 */
export const returnPayoutRequest = (
  id: string,
  returnPayoutRequestDto: ReturnPayoutRequestDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutRequestDto>> => {
  return axios.default.post(
    `/api/payout-requests/${id}/return`,
    returnPayoutRequestDto,
    options,
  );
};

export const getReturnPayoutRequestMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof returnPayoutRequest>>,
    TError,
    { id: string; data: ReturnPayoutRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof returnPayoutRequest>>,
  TError,
  { id: string; data: ReturnPayoutRequestDto },
  TContext
> => {
  const mutationKey = ["returnPayoutRequest"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof returnPayoutRequest>>,
    { id: string; data: ReturnPayoutRequestDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return returnPayoutRequest(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReturnPayoutRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof returnPayoutRequest>>
>;
export type ReturnPayoutRequestMutationBody = ReturnPayoutRequestDto;
export type ReturnPayoutRequestMutationError =
  AxiosError<ProblemDetails | void>;

export const useReturnPayoutRequest = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof returnPayoutRequest>>,
    TError,
    { id: string; data: ReturnPayoutRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof returnPayoutRequest>>,
  TError,
  { id: string; data: ReturnPayoutRequestDto },
  TContext
> => {
  const mutationOptions = getReturnPayoutRequestMutationOptions(options);

  return useMutation(mutationOptions);
};
